import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('blacklist-ips')
  .extendHookCollectionsFactory('blacklist-ips')
  .factory()

export {
  Provider as IpBlacklistProvider,
  useStore as useIpBlacklistStore,
}
